import { AnyAction } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { Epic } from 'redux-observable'
import { of, from } from 'rxjs'
import { switchMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators'

import {
  createPreContract,
  createPreContractSuccess,
  createPreContractError,
} from './contract.reducer'

import { RootState } from '../../core/store/root.reducer'
import { GenericError } from '../model/contract.model'
import ContractService from '../services/contract.service'

const createPreContractEpic: Epic<
  AnyAction,
  AnyAction,
  RootState,
  { contractService: ContractService }
> = (action$, state$, { contractService }) =>
  action$.pipe(
    filter(createPreContract.match),
    withLatestFrom(state$),
    switchMap(([action]) =>
      from(contractService.createPreContract(action.payload)).pipe(
        map(({ data, status }) => createPreContractSuccess({ data, httpStatus: status })),
        catchError((error: AxiosError<GenericError>) =>
          of(
            createPreContractError({
              errorCode: error?.response?.data?.code,
              errorMessage: error?.response?.data?.detailMsg,
              httpStatus: error?.response?.status,
            }),
          ),
        ),
      ),
    ),
  )

const contractEpics = {
  createPreContractEpic,
}

export default contractEpics
